const petVaccines = [
    { value: 'rabies', label: { en: 'Rabies', es: 'Rabia' } },
    { value: 'distemper', label: { en: 'Distemper (Dogs)', es: 'Moquillo (Perros)' } },
    { value: 'parvovirus', label: { en: 'Parvovirus (Dogs)', es: 'Parvovirus (Perros)' } },
    { value: 'hepatitis', label: { en: 'Canine Hepatitis', es: 'Hepatitis Canina' } },
    { value: 'bordetella', label: { en: 'Bordetella (Kennel Cough)', es: 'Bordetella (Tos de las Perreras)' } },
    { value: 'leptospirosis', label: { en: 'Leptospirosis (Dogs)', es: 'Leptospirosis (Perros)' } },
    { value: 'feline_viral_rhinotracheitis', label: { en: 'Feline Viral Rhinotracheitis (Cats)', es: 'Rinotraqueítis Viral Felina (Gatos)' } },
    { value: 'calicivirus', label: { en: 'Feline Calicivirus (Cats)', es: 'Calicivirus Felino (Gatos)' } },
    { value: 'panleukopenia', label: { en: 'Feline Panleukopenia (Cats)', es: 'Panleucopenia Felina (Gatos)' } },
    { value: 'feline_leukemia', label: { en: 'Feline Leukemia Virus (FeLV)', es: 'Virus de la Leucemia Felina (FeLV)' } },
    { value: 'myxomatosis', label: { en: 'Myxomatosis (Rabbits)', es: 'Mixomatosis (Conejos)' } },
    { value: 'rvhd', label: { en: 'Rabbit Viral Hemorrhagic Disease (RVHD)', es: 'Enfermedad Hemorrágica Viral del Conejo (RVHD)' } },
];

export default petVaccines;